import { restApiActions } from 'redux/redux-actions';

export const buyersAcceptActions = restApiActions('buyers', 'accept');
export const buyersPaymentDetailActions = restApiActions('buyers', 'paymentDetail');

export default restApiActions('buyers');
